export const buttonVariants = {
  initial: {
    backgroundColor: "#FFFFFF",
    transition: { type: "spring", bounce: 0.25, duration: 0.5 },
  },
  hover: {
    backgroundColor: "#685BB5",
    transition: { type: "spring", bounce: 0.25, duration: 0.5 },
  },
  tap: {
    backgroundColor: "#685BB5",
    transition: { type: "spring", bounce: 0.25, duration: 0.125 },
  },
}

export const scrimVariants = {
  tap: {
    opacity: 0.3,
    transition: { type: "spring", bounce: 0.25, duration: 0.125 },
  },
}

export const iconVariants = {
  initial: {
    color: "#685BB5",
    transition: { type: "spring", bounce: 0.25, duration: 0.5 },
  },
  hover: {
    color: "#FFFFFF",
    transition: { type: "spring", bounce: 0.25, duration: 0.125 },
  },
  tap: {
    color: "#FFFFFF",
    transition: { type: "spring", bounce: 0.25, duration: 0.125 },
  },
}
